(function () {
  'use strict';

  angular.module('app').component('productCategoryList', productCategoryList());

  function productCategoryList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
      },
      controller: ProductCategoryListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/product-categories/product-category-list/product-category-list.component.html',
    };
  }

  ProductCategoryListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'ProductCategoryService',
  ];

  function ProductCategoryListCtrl(config, UtilService, AbilityService, ProductCategoryService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_productcategory_accountadmin'), //,
      // canUpdate:  AbilityService.can('update_productcategory_accountadmin'),
      // canDestroy: AbilityService.can('destroy_productcategory_accountadmin')
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ProductCategoryService.getFilterCriteria();

    vm.codingTypes = config.CODING_TYPES;

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    // vm.deleteItem       = deleteItem;
    // vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems    = onUpdateItems;

    // Initializers
    getProductTypes();

    function getProductTypes() {
      vm.productTypes = vm.UtilService.getProductTypes();
    }

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      ProductCategoryService.getProductCategories(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ProductCategoryService.getFilterCriteria();
      fetchResult();
    }

    function selectPage(page) {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowItem({ item: item, mode: mode });
    }

    /*function deleteItem(item) {
            ProductCategoryService.deleteProductCategory(item, fetchResult);
        }

        function changeItemStatus(item) {
            ProductCategoryService.changeProductCategoryStatus(item);
        }

        function onUpdateItems(action) {
            var successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };

            ProductCategoryService.updateProductCategories(action, vm.items, successCallback);
        }*/
  }
})();
